import { useContext, useEffect, useState } from "react";
import Skeleton from "@mui/material/Skeleton";
import AppStateContext from "../contexts/AppStateContext";
import { UserType } from "types/users/UserTypes";
import { apiGetMe } from "util/network/Users";

/** Signed-in user shown at the top of the sidebar. Falls back to the first
 *  employee while /me has not answered yet. */
const SidebarProfile = () => {
  const { token, employees } = useContext(AppStateContext);
  const [me, setMe] = useState<UserType | null>(null);

  useEffect(() => {
    if (!token) return;

    let cancelled = false;
    apiGetMe(token)
      .then((data) => {
        if (!cancelled) setMe(data);
      })
      .catch((error) => {
        console.error(error);
      });

    return () => {
      cancelled = true;
    };
  }, [token]);

  const fallback = employees.items[0];
  const firstName = me?.firstName || fallback?.firstName || "";
  const lastName = me?.lastName || fallback?.lastName || "";
  const email = me?.email || fallback?.email || "";
  const company =
    me?.defaultBillingAddress?.company ||
    fallback?.defaultBillingAddress?.company ||
    "";

  return (
    <div
      style={{
        background: "#000",
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-end",
        paddingLeft: "1rem",
        paddingTop: "2rem",
        paddingBottom: "0.5rem",
      }}
    >
      <span
        style={{
          textTransform: "uppercase",
          borderRadius: "20px",
          height: "fit-content",
          background: "var(--header)",
          padding: "0.5rem",
          fontWeight: "bold",
        }}
      >
        {email ? (
          email.substring(0, 3)
        ) : (
          <Skeleton
            variant="circular"
            width={22}
            height={22}
            sx={{ bgcolor: "grey.900" }}
          />
        )}
      </span>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          paddingLeft: "1rem",
        }}
      >
        <span style={{ fontSize: "1.2rem" }}>
          {firstName && lastName ? (
            `${firstName} ${lastName}`
          ) : (
            <Skeleton
              variant="rectangular"
              width={100}
              height={20}
              sx={{ bgcolor: "grey.900" }}
            />
          )}
        </span>
        <span style={{ fontSize: "0.8rem" }}>
          {company ? (
            company
          ) : (
            <Skeleton
              variant="text"
              sx={{ bgcolor: "grey.900", fontSize: "1rem" }}
            />
          )}
        </span>
      </div>
    </div>
  );
};

export default SidebarProfile;
